"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jumpApi = _interopRequireWildcard(require("@/api/jumpApi"));
var _companyappApi = require("@/api/companyappApi");
var _rensouApi = require("@/api/rensou/rensouApi");
var _rsManagement = require("@/api/rsManagement");
var _validate = require("@/utils/validate");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    userType: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      brandOption: [],
      customerList: [],
      jumpType: [],
      typeDisable: false,
      localUserType: null,
      currentCustomerId: null,
      rsStoreOptions: [],
      rsStoreTypeList: [],
      rsStoreLoading: false,
      rsStoreTypeLoading: false
    };
  },
  watch: {
    customerList: {
      handler: function handler() {
        var _this = this;
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // 小程序客户 + cookie customerId 已知 + 列表加载完 + pram.customerId 仍未设置 → 自动回填
        if (this.isMiniProgramCustomer && this.currentCustomerId != null && !this.pram.customerId) {
          var hit = list.find(function (it) {
            return String(it.id) === String(_this.currentCustomerId);
          });
          if (hit) {
            this.$set(this.pram, 'customerId', hit.id);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    this.jumpType = jumpApi.getJumpOptions();
    if (this.userType == null) {
      try {
        var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        this.localUserType = JavaInfo.type;
        this.currentCustomerId = JavaInfo.customerId || null;
      } catch (e) {
        this.localUserType = null;
        this.currentCustomerId = null;
      }
    } else {
      try {
        var _JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        this.currentCustomerId = _JavaInfo.customerId || null;
      } catch (e) {
        this.currentCustomerId = null;
      }
    }
    this.loadCustomerList();
  },
  computed: {
    resolvedUserType: function resolvedUserType() {
      return this.userType != null ? this.userType : this.localUserType;
    },
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      return Number(this.resolvedUserType) === 5;
    },
    filteredJumpType: function filteredJumpType() {
      if (this.isMiniProgramCustomer) {
        return this.jumpType.filter(function (item) {
          return item.key === 'skin' || item.key === 'rsTakeout';
        });
      }
      return this.jumpType;
    },
    exParams: function exParams() {
      var _this$pram,
        _this2 = this,
        _this$filteredJumpTyp;
      if (!((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.urlType)) return {};
      var idx = this.filteredJumpType.findIndex(function (item) {
        return item.key == _this2.pram.urlType;
      });
      return ((_this$filteredJumpTyp = this.filteredJumpType) === null || _this$filteredJumpTyp === void 0 ? void 0 : _this$filteredJumpTyp[idx]) || {};
    },
    isLypCate: function isLypCate() {
      var _this$pram2;
      return ((_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : _this$pram2.urlType) === 'lypCate';
    },
    isMiniProgram: function isMiniProgram() {
      var _this$pram3;
      return ((_this$pram3 = this.pram) === null || _this$pram3 === void 0 ? void 0 : _this$pram3.urlType) === 'miniProgram';
    },
    isRsTakeout: function isRsTakeout() {
      var _this$pram4;
      return ((_this$pram4 = this.pram) === null || _this$pram4 === void 0 ? void 0 : _this$pram4.urlType) === 'rsTakeout';
    },
    rsBizTypeCode: function rsBizTypeCode() {
      if (this.pram.rsBizType === 'group') return 2;
      if (this.pram.rsBizType === 'hotel') return 3;
      return 1;
    },
    rsStoreTypeOptions: function rsStoreTypeOptions() {
      var _this3 = this;
      return (this.rsStoreTypeList || []).filter(function (item) {
        return Number(item.type) === _this3.rsBizTypeCode;
      });
    },
    displayUrlParam: function displayUrlParam() {
      var _this$pram5;
      if (this.isLypCate) return this.buildUrlParam('lypCate');
      if (this.isRsTakeout) return this.buildUrlParam('rsTakeout');
      return ((_this$pram5 = this.pram) === null || _this$pram5 === void 0 ? void 0 : _this$pram5.urlParam) || '';
    }
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(tagDetails) {
      var _fuIds,
        _fuIds2,
        _this4 = this;
      this.typeDisable = false;
      var _ref = tagDetails || {},
        fuCartIds = _ref.fuCartIds;
      var fuIds = (fuCartIds === null || fuCartIds === void 0 ? void 0 : fuCartIds.split(',')) || [];
      fuIds = (_fuIds = fuIds) === null || _fuIds === void 0 ? void 0 : _fuIds.filter(function (item) {
        return item;
      });
      var lypParams = this.parseLypUrlParam(tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.urlParam);
      var rsParams = this.parseRsTakeoutUrlParam((tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.urlType) === 'rsTakeout' ? tagDetails === null || tagDetails === void 0 ? void 0 : tagDetails.urlParam : '');
      this.pram = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tagDetails), lypParams), rsParams), {}, {
        fuCartIds: ((_fuIds2 = fuIds) === null || _fuIds2 === void 0 ? void 0 : _fuIds2.map(function (item) {
          return Number(item);
        })) || []
      });
      if (this.isMiniProgramCustomer) {
        var allowed = ['skin', 'rsTakeout'];
        if (!allowed.includes(this.pram.urlType)) {
          this.$set(this.pram, 'urlType', 'skin');
        }
        // 新增时（无 customerId）默认填当前登录客户；编辑时保留原值
        if (!this.pram.customerId && this.currentCustomerId != null) {
          var hit = this.customerList.find(function (it) {
            return String(it.id) === String(_this4.currentCustomerId);
          });
          if (hit) {
            this.$set(this.pram, 'customerId', hit.id);
          } else {
            this.$set(this.pram, 'customerId', this.currentCustomerId);
          }
        }
      } else if (this.pram.urlType === 'lypCate' && !this.pram.lypType) {
        this.$set(this.pram, 'lypType', 'lypJd');
      }
      this.syncLypUrlParam();
      this.syncRsTakeoutUrlParam();
      this.visible = true;
      this.searchBrand('');
      this.loadCustomerList();
      if (this.pram.urlType === 'rsTakeout') {
        this.searchRsStore('');
        this.searchRsStoreType('');
      }
      this.$nextTick(function () {
        _this4.$refs.pram && _this4.$refs.pram.clearValidate();
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this$pram6,
        _this5 = this;
      if (this.exParams.paramInput === 'dualCate') {
        this.syncLypMemuUrlParam();
      }
      if (((_this$pram6 = this.pram) === null || _this$pram6 === void 0 ? void 0 : _this$pram6.urlType) === 'rsTakeout') {
        this.syncRsTakeoutUrlParam();
      }
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this5.loading = true;
        var _this5$pram = _this5.pram,
          authority = _this5$pram.authority,
          _this5$pram$fuCartIds = _this5$pram.fuCartIds,
          fuCartIds = _this5$pram$fuCartIds === void 0 ? [] : _this5$pram$fuCartIds,
          id = _this5$pram.id,
          url = _this5$pram.url,
          urlName = _this5$pram.urlName,
          urlParam = _this5$pram.urlParam,
          urlType = _this5$pram.urlType,
          customerId = _this5$pram.customerId;
        var _ref2 = _this5.exParams || {},
          hasParams = _ref2.hasParams,
          baseUrl = _ref2.baseUrl;
        var finalUrlParam = _this5.buildUrlParam(urlType, urlParam);
        jumpApi.jumpAddArticle({
          authority: authority,
          id: id,
          urlName: urlName,
          urlType: urlType,
          customerId: customerId || null,
          fuCartIds: authority ? fuCartIds === null || fuCartIds === void 0 ? void 0 : fuCartIds.join(',') : '',
          url: urlType === 'other' ? url : urlType === 'miniProgram' ? 'miniProgram' : baseUrl,
          urlParam: urlType === 'miniProgram' ? urlParam : hasParams ? finalUrlParam : ''
        }).then(function (data) {
          _this5.$message.success('操作成功');
          _this5.loading = false;
          _this5.visible = false;
          _this5.$emit('doRefresh');
        }).catch(function () {
          _this5.loading = false;
        });
      });
    }),
    changeSelect: function changeSelect() {
      var _this$pram7, _this$pram8, _this$pram9, _this$pram0, _this$pram1;
      if (((_this$pram7 = this.pram) === null || _this$pram7 === void 0 ? void 0 : _this$pram7.urlType) === 'miniProgram') {
        this.$set(this.pram, 'url', 'miniProgram');
        this.$set(this.pram, 'urlParam', this.pram.urlParam || '');
      }
      if (((_this$pram8 = this.pram) === null || _this$pram8 === void 0 ? void 0 : _this$pram8.urlType) === 'lypCate') {
        this.$set(this.pram, 'lypType', this.pram.lypType || 'lypJd');
        this.$set(this.pram, 'lypScid', this.pram.lypScid || '');
        this.$set(this.pram, 'lypTwoId', this.pram.lypTwoId || '');
        this.syncLypUrlParam();
      }
      if (((_this$pram9 = this.pram) === null || _this$pram9 === void 0 ? void 0 : _this$pram9.urlType) === 'rsTakeout') {
        this.$set(this.pram, 'rsBizType', this.pram.rsBizType || 'takeout');
        this.$set(this.pram, 'rsStoreId', this.pram.rsStoreId || '');
        this.$set(this.pram, 'rsStoreTypeId', this.pram.rsStoreTypeId || '');
        this.$set(this.pram, 'rsOneId', this.pram.rsOneId || '');
        this.$set(this.pram, 'rsTwoId', this.pram.rsTwoId || '');
        this.syncRsTakeoutUrlParam();
        this.searchRsStore('');
        this.searchRsStoreType('');
      }
      if (['card', 'other'].includes((_this$pram0 = this.pram) === null || _this$pram0 === void 0 ? void 0 : _this$pram0.urlType)) {
        this.$set(this.pram, 'authority', 0);
        this.typeDisable = true;
      } else {
        this.typeDisable = false;
      }
      if (((_this$pram1 = this.pram) === null || _this$pram1 === void 0 ? void 0 : _this$pram1.urlType) === 'lypMemu') {
        if (this.pram.lypCategoryLv1 === undefined) this.$set(this.pram, 'lypCategoryLv1', '');
        if (this.pram.lypCategoryLv2 === undefined) this.$set(this.pram, 'lypCategoryLv2', '');
        if (this.pram.lypMemuChannel === undefined || this.pram.lypMemuChannel === '') {
          this.$set(this.pram, 'lypMemuChannel', 'lypJd');
        }
        this.syncLypMemuUrlParam();
      }
    },
    parseLypMemuUrlParam: function parseLypMemuUrlParam(str) {
      var lv1 = '';
      var lv2 = '';
      var type = '';
      if (!str) return {
        lv1: lv1,
        lv2: lv2,
        type: type
      };
      var q = String(str).replace(/^\?/, '');
      q.split('&').forEach(function (pair) {
        var eq = pair.indexOf('=');
        var k = eq >= 0 ? pair.slice(0, eq) : pair;
        var v = eq >= 0 ? pair.slice(eq + 1) : '';
        if (k === 'scid') lv1 = String(v).replace(/\D/g, '');
        if (k === 'twoId') lv2 = String(v).replace(/\D/g, '');
        if (k === 'type' && (v === 'lypJd' || v === 'lypSam')) type = v;
      });
      return {
        lv1: lv1,
        lv2: lv2,
        type: type
      };
    },
    syncLypMemuUrlParam: function syncLypMemuUrlParam() {
      if (this.pram.urlType !== 'lypMemu') return;
      var a = String(this.pram.lypCategoryLv1 || '').replace(/\D/g, '');
      var b = String(this.pram.lypCategoryLv2 || '').replace(/\D/g, '');
      var chRaw = String(this.pram.lypMemuChannel || '').trim();
      var ch = chRaw === 'lypSam' ? 'lypSam' : chRaw === 'lypJd' ? 'lypJd' : '';
      var p = '';
      if (a) p = "scid=".concat(a);
      if (b) p += (p ? '&' : '') + "twoId=".concat(b);
      if (ch) p += (p ? '&' : '') + "type=".concat(ch);
      this.$set(this.pram, 'urlParam', p);
    },
    onLypMemuLv1Input: function onLypMemuLv1Input(val) {
      var v = String(val || '').replace(/\D/g, '');
      this.$set(this.pram, 'lypCategoryLv1', v);
      this.syncLypMemuUrlParam();
    },
    onLypMemuLv2Input: function onLypMemuLv2Input(val) {
      var v = String(val || '').replace(/\D/g, '');
      this.$set(this.pram, 'lypCategoryLv2', v);
      this.syncLypMemuUrlParam();
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    loadCustomerList: function () {
      var _loadCustomerList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _companyappApi.customersListApi)({
                types: 3
              });
            case 1:
              res = _context.v;
              this.customerList = res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.customerList = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCustomerList() {
        return _loadCustomerList.apply(this, arguments);
      }
      return loadCustomerList;
    }(),
    searchBrand: function searchBrand() {
      var _this6 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      jumpApi.selectCard(keyword).then(function (res) {
        _this6.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchBrand(data);
      }, 300)();
    },
    remoteMethod: function remoteMethod() {
      this.searchBrand('');
    },
    buildUrlParam: function buildUrlParam(urlType) {
      var fallbackParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (urlType === 'rsTakeout') return this.buildRsTakeoutUrlParam();
      if (urlType !== 'lypCate') return fallbackParam;
      var scid = (this.pram.lypScid || '').trim();
      var twoId = (this.pram.lypTwoId || '').trim();
      var type = this.pram.lypType || 'lypJd';
      var params = ["scid=".concat(scid)];
      if (twoId) params.push("twoId=".concat(twoId));
      params.push("type=".concat(type));
      return params.join('&');
    },
    parseLypUrlParam: function parseLypUrlParam() {
      var urlParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!urlParam) {
        return {
          lypType: 'lypJd',
          lypScid: '',
          lypTwoId: ''
        };
      }
      var searchParams = new URLSearchParams(urlParam);
      return {
        lypType: searchParams.get('type') || 'lypJd',
        lypScid: searchParams.get('scid') || '',
        lypTwoId: searchParams.get('twoId') || ''
      };
    },
    syncLypUrlParam: function syncLypUrlParam() {
      var _this$pram10;
      if (((_this$pram10 = this.pram) === null || _this$pram10 === void 0 ? void 0 : _this$pram10.urlType) !== 'lypCate') return;
      this.$set(this.pram, 'urlParam', this.buildUrlParam('lypCate'));
    },
    onRsBizTypeChange: function onRsBizTypeChange() {
      var _this8 = this;
      this.$set(this.pram, 'rsStoreTypeId', '');
      this.syncRsTakeoutUrlParam();
      this.$nextTick(function () {
        _this8.$refs.pram && _this8.$refs.pram.clearValidate();
      });
    },
    parseRsTakeoutUrlParam: function parseRsTakeoutUrlParam() {
      var urlParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var empty = {
        rsBizType: 'takeout',
        rsStoreId: '',
        rsStoreTypeId: '',
        rsOneId: '',
        rsTwoId: ''
      };
      if (!urlParam) return empty;
      var searchParams = new URLSearchParams(urlParam);
      var type = searchParams.get('type');
      var rsBizType = 'takeout';
      if (type === '2') rsBizType = 'group';else if (type === '3') rsBizType = 'hotel';
      var storeId = searchParams.get('storeId');
      var storeTypeId = searchParams.get('storeTypeId');
      return {
        rsBizType: rsBizType,
        rsStoreId: storeId ? Number(storeId) : '',
        rsStoreTypeId: storeTypeId ? Number(storeTypeId) : '',
        rsOneId: searchParams.get('oneId') || '',
        rsTwoId: searchParams.get('twoId') || ''
      };
    },
    buildRsTakeoutUrlParam: function buildRsTakeoutUrlParam() {
      var oneId = (this.pram.rsOneId || '').trim();
      var twoId = (this.pram.rsTwoId || '').trim();
      var storeId = this.pram.rsStoreId != null && this.pram.rsStoreId !== '' ? String(this.pram.rsStoreId) : '';
      var storeTypeId = this.pram.rsStoreTypeId != null && this.pram.rsStoreTypeId !== '' ? String(this.pram.rsStoreTypeId) : '';
      var params = [];
      if (this.pram.rsBizType === 'group') {
        params.push('detailType=2', 'type=2');
      } else if (this.pram.rsBizType === 'hotel') {
        params.push('detailType=2', 'type=3');
      }
      if (storeId) params.push("storeId=".concat(storeId));
      if (storeTypeId) params.push("storeTypeId=".concat(storeTypeId));
      if (oneId) params.push("oneId=".concat(oneId));
      if (twoId) params.push("twoId=".concat(twoId));
      return params.join('&');
    },
    formatRsOptionLabel: function formatRsOptionLabel(item) {
      if (!item) return '';
      var id = item.key != null ? item.key : '';
      var name = item.value || '';
      return name ? "id:".concat(id, "-").concat(name) : "id:".concat(id);
    },
    normalizeRsOptions: function normalizeRsOptions(res) {
      var list = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
      return list.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          key: item.key != null ? Number(item.key) : item.key,
          value: item.value || item.name || '',
          type: item.type != null ? Number(item.type) : item.type
        });
      }).filter(function (item) {
        return item.key != null && item.key !== '';
      });
    },
    mergeRsSelectedOption: function mergeRsSelectedOption(options, selectedId) {
      if (selectedId == null || selectedId === '') return options;
      var id = Number(selectedId);
      if (!id || options.some(function (item) {
        return Number(item.key) === id;
      })) return options;
      return [{
        key: id,
        value: String(selectedId)
      }].concat(options);
    },
    searchRsStore: function searchRsStore() {
      var _this9 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this._rsStoreTimer) clearTimeout(this._rsStoreTimer);
      this._rsStoreTimer = setTimeout(function () {
        _this9.rsStoreLoading = true;
        var kw = String(keyword || '').trim();
        (0, _rensouApi.getStore)(kw ? {
          keyword: kw,
          keywords: kw
        } : {}).then(function (res) {
          _this9.rsStoreOptions = _this9.mergeRsSelectedOption(_this9.normalizeRsOptions(res), _this9.pram.rsStoreId);
        }).catch(function () {
          _this9.rsStoreOptions = _this9.mergeRsSelectedOption([], _this9.pram.rsStoreId);
        }).finally(function () {
          _this9.rsStoreLoading = false;
        });
      }, 300);
    },
    searchRsStoreType: function searchRsStoreType() {
      var _this0 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this._rsStoreTypeTimer) clearTimeout(this._rsStoreTypeTimer);
      this._rsStoreTypeTimer = setTimeout(function () {
        _this0.rsStoreTypeLoading = true;
        var kw = String(keyword || '').trim();
        (0, _rsManagement.getMerchantStoreTypeList)(kw ? {
          keyword: kw
        } : {}).then(function (res) {
          _this0.rsStoreTypeList = _this0.normalizeRsOptions(res);
        }).catch(function () {
          _this0.rsStoreTypeList = [];
        }).finally(function () {
          _this0.rsStoreTypeLoading = false;
        });
      }, 300);
    },
    onRsStoreFocus: function onRsStoreFocus() {
      if (!this.rsStoreOptions.length) this.searchRsStore('');
    },
    onRsStoreTypeFocus: function onRsStoreTypeFocus() {
      if (!this.rsStoreTypeList.length) this.searchRsStoreType('');
    },
    syncRsTakeoutUrlParam: function syncRsTakeoutUrlParam() {
      var _this$pram11;
      if (((_this$pram11 = this.pram) === null || _this$pram11 === void 0 ? void 0 : _this$pram11.urlType) !== 'rsTakeout') return;
      this.$set(this.pram, 'urlParam', this.buildRsTakeoutUrlParam());
    }
  }
};